import { BaseApiResponse } from '../../types';
import { simpleQueryServerData } from '../simpleQueryServerData';

/**
 * decode given code to navigation system data
 */
export async function ubdateTimeSession(): Promise<BaseApiResponse<any>> {
    return simpleQueryServerData('api_react/ubdateTimeSession.php', 'GET');
}
